import React from 'react';
import { ReactComponent as CommentBubbleIcon } from '../../icons/comment-bubble.svg';
import './comment-count-button.scss';

interface CommentCountButtonProps {
  count: number;
  hasLoaded: boolean;
  isExpanded: boolean;
  onClick: () => void;
}

/**
 * Reusable component for displaying a comment/reply count button
 */
const CommentCountButton: React.FC<CommentCountButtonProps> = ({
  count,
  hasLoaded,
  isExpanded,
  onClick,
}) => {
  const hasComments = hasLoaded && count > 0;

  return (
    <div className='comment action-buttons'>
      <button
        className={`comment-count-button ${hasComments ? 'active' : ''} ${isExpanded ? 'depressed' : ''}`}
        onClick={onClick}
        title={
          hasComments
            ? isExpanded
              ? 'Collapse notes'
              : 'Expand notes'
            : 'Add note'
        }
      >
        <CommentBubbleIcon />
        {hasComments && <span className='comment-count'>{count}</span>}
      </button>
    </div>
  );
};

export default CommentCountButton;
